import { SettingsOutlined } from '@mui/icons-material';
import { Tabs } from 'finara-components';
import { useState } from 'react';

import { Navbar } from '@/components/admin/general/Navbar';
import { CreditSettingsCard } from '@/components/admin/settings/CreditSettingsCard';
import { PayrollConfigCard } from '@/components/admin/settings/PayrollConfigCard';
import { PayrollPayableCard } from '@/components/admin/settings/PayrollPayableCard';
import { RatesManagementCard } from '@/components/admin/settings/RatesManagementCard';
import { TransactionLimitsCard } from '@/components/admin/settings/TransactionLimitsCard';
import { adminNavItems } from '@/data/admin/general/navigationData';
import { useAuth } from '@/hooks/useAuth';

type SettingTab = 'credit' | 'limits' | 'payroll' | 'rates';

interface Tab {
  id: string;
  title: string;
  onSelect: () => void;
}

export const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<SettingTab>('credit');

  const tabs: Tab[] = [
    {
      id: 'credit',
      title: 'Créditos',
      onSelect: () => setActiveTab('credit'),
    },
    {
      id: 'limits',
      title: 'Límites',
      onSelect: () => setActiveTab('limits'),
    },
    {
      id: 'payroll',
      title: 'Nómina',
      onSelect: () => setActiveTab('payroll'),
    },
    {
      id: 'rates',
      title: 'Tasas',
      onSelect: () => setActiveTab('rates'),
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'credit':
        return <CreditSettingsCard />;
      case 'limits':
        return <TransactionLimitsCard />;
      case 'payroll':
        return (
          <div className="space-y-6">
            <PayrollConfigCard />
            <PayrollPayableCard />
          </div>
        );
      case 'rates':
        return <RatesManagementCard />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar
        navItems={adminNavItems}
        userName={user?.name || 'Usuario'}
        pageTitle="Configuración"
        section="Configuración"
      />

      <div className="px-4 py-8">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <SettingsOutlined className="text-brand-blue" />
            <h1 className="text-2xl font-bold text-brand-white">Configuración Empresarial</h1>
          </div>
          <p className="text-muted mt-1">
            Configura los parámetros de créditos, límites de transacciones, nómina y tasas de
            interés para tu organización
          </p>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <Tabs tabs={tabs} activeTabId={activeTab} />
        </div>

        {/* Tab Content */}
        <div>{renderTabContent()}</div>
      </div>
    </div>
  );
};
